import axios from "axios/index";
import { dispatchError, API_BASE, config as ApiConfig } from "../api";

export default store => {
  return {
    $store: store,
    decoding(data) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "post",
          url: API_BASE + `/decoding/`,
          data: data
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    retrieve_epc(params) {
        this.$store.commit("loading", true);
  
        params = params === undefined ? {} : params;
  
        return axios(
          Object.assign(ApiConfig(this.$store), {
            method: "get",
            url: API_BASE + `/items/`,
            params
          })
        )
          .then(response => {
            this.$store.commit("loading", false);
            return response.data;
          })
          .catch(error => {
            if (error.response === undefined) {
              dispatchError(
                this.$store,
                "Error de conexión. Inténtelo más tarde"
              );
            } else {
              dispatchError(this.$store, error.response.data.message);
              throw error;
            }
          });
      },
      item_stock(id, params) {
        this.$store.commit("loading", true);
  
        params = params === undefined ? {} : params;
  
        return axios(
          Object.assign(ApiConfig(this.$store), {
            method: "get",
            url: API_BASE + `/items/${id}/itemstock/`,
            params
          })
        )
          .then(response => {
            this.$store.commit("loading", false);
            return response.data;
          })
          .catch(error => {
            if (error.response === undefined) {
              dispatchError(
                this.$store,
                "Error de conexión. Inténtelo más tarde"
              );
            } else {
              dispatchError(this.$store, error.response.data.message);
              throw error;
            }
          });
      },
  };
};
